import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { push } from 'connected-react-router';

import Brand from 'models/brand';
import VehicleForm from 'components/account/saved-vehicles/vehicle-form';
import saveNewVehicleCreator from 'action-creators/vehicles/save-new-vehicle';
import AccountHeadline from 'components/common/account/account-headline';
import trackEventCreator from 'action-creators/analytics/track-event';

const propTypes = {
  brand: PropTypes.instanceOf(Brand).isRequired,
  dismissPage: PropTypes.func.isRequired,
  saveNewVehicle: PropTypes.func.isRequired,
  app: PropTypes.string.isRequired,
  trackEvent: PropTypes.func.isRequired,
};

const defaultProps = {
};

class NewSavedVehicleWrapper extends Component {
  constructor(props) {
    super(props);

    this.dismissPage = this.dismissPage.bind(this);
  }

  dismissPage() {
    if (window.confirm('Are you sure you want to dismiss your changes?')) {
      this.props.dismissPage();
    }
  }

  render() {
    return (
      <div>
        <AccountHeadline brand={this.props.brand} headline="MANAGE SAVED VEHICLES" app={this.props.app} trackEvent={this.props.trackEvent} />
        <div className="heavy-shadowed area dismissable">
          <div className="dismiss-button clickable" onClick={this.dismissPage} />
          <div className="row">
            <div className="col-md-10 col-md-offset-1 padding-0">
              <h4 className="h4-sg text-color-slate text-weight-medium with-bottom-margin-2x">ADD A VEHICLE</h4>
              <div className="col-md-10 padding-0">
                <VehicleForm saveOrUpdateVehicle={this.props.saveNewVehicle} brand={this.props.brand} />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

NewSavedVehicleWrapper.propTypes = propTypes;
NewSavedVehicleWrapper.defaultProps = defaultProps;

const dismissPage = () => push('/account/vehicles');

const mapStateToProps = (state) => {
  const {
    brand,
  } = state.brand;
  return {
    brand,
  };
};

const mapDispatchToProps = dispatch => (
  bindActionCreators({
    dismissPage,
    saveNewVehicle: saveNewVehicleCreator,
    trackEvent: trackEventCreator,
  }, dispatch)
);

export default connect(mapStateToProps, mapDispatchToProps)(NewSavedVehicleWrapper);
